import CardExample from "./examples/Card.Example";
import SummaryCardExample from "./examples/SummaryCard.Example";
import TableCardExample from "./examples/TableCard.Example";

export default [
    {
        title: "Basic card",
        component: CardExample,
        code: require("!raw-loader!./examples/Card.Example.tsx")
    },
    {
        title: "Summary card",
        component: SummaryCardExample,
        code: require("!raw-loader!./examples/SummaryCard.Example.tsx")
    },
    {
        title: "Advanced card",
        component: TableCardExample,
        code: require("!raw-loader!./examples/TableCard.Example.tsx")
    }
];
